import { render, staticRenderFns } from "./PdfConsignmentInvoice.vue?vue&type=template&id=cb401d7a&"
import script from "./PdfConsignmentInvoice.vue?vue&type=script&lang=js&"
export * from "./PdfConsignmentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PdfConsignmentInvoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
